import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCustomerEffectiveConfigQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetCustomerEffectiveConfigQuery = { __typename?: 'query_root', customers_by_pk?: { __typename?: 'customers', id: number, effective_config?: object | null } | null };


export const GetCustomerEffectiveConfigDocument = gql`
    query getCustomerEffectiveConfig($customerId: bigint!) {
  customers_by_pk(id: $customerId) {
    id
    effective_config
  }
}
    `;

/**
 * __useGetCustomerEffectiveConfigQuery__
 *
 * To run a query within a React component, call `useGetCustomerEffectiveConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerEffectiveConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerEffectiveConfigQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerEffectiveConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables> & ({ variables: GetCustomerEffectiveConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>(GetCustomerEffectiveConfigDocument, options);
      }
export function useGetCustomerEffectiveConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>(GetCustomerEffectiveConfigDocument, options);
        }
// @ts-ignore
export function useGetCustomerEffectiveConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>;
export function useGetCustomerEffectiveConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerEffectiveConfigQuery | undefined, GetCustomerEffectiveConfigQueryVariables>;
export function useGetCustomerEffectiveConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>(GetCustomerEffectiveConfigDocument, options);
        }
export type GetCustomerEffectiveConfigQueryHookResult = ReturnType<typeof useGetCustomerEffectiveConfigQuery>;
export type GetCustomerEffectiveConfigLazyQueryHookResult = ReturnType<typeof useGetCustomerEffectiveConfigLazyQuery>;
export type GetCustomerEffectiveConfigSuspenseQueryHookResult = ReturnType<typeof useGetCustomerEffectiveConfigSuspenseQuery>;
export type GetCustomerEffectiveConfigQueryResult = Apollo.QueryResult<GetCustomerEffectiveConfigQuery, GetCustomerEffectiveConfigQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getCustomerEffectiveConfig.query.gql}
 */
export async function getCustomerEffectiveConfig(
  variables: GetCustomerEffectiveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomerEffectiveConfigQuery['customers_by_pk']>
export async function getCustomerEffectiveConfig(
  variables: GetCustomerEffectiveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomerEffectiveConfigQuery>
export async function getCustomerEffectiveConfig(
  variables: GetCustomerEffectiveConfigQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomerEffectiveConfigQuery['customers_by_pk'] | GetCustomerEffectiveConfigQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomerEffectiveConfigQuery>(
    GetCustomerEffectiveConfigDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers_by_pk
}